import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { catchError, retry } from 'rxjs/operators';
import { URL_API } from 'src/app/tools/URL';
import { ATUALIZAR, CARREGAR, ENVIAR, ErrorsService, SALVAR } from '../errors/errors.service';
import { CriticaVO } from './../../entity/CriticaVO';
import { RestService } from './../rest.service';
import { AuthService } from '../autenticacao/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CriticaService {

  critica = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) {
  }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_CRITICA}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_CRITICA + '/' + id}`);

  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      this.critica.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.critica.controls.listaCartorio.setValue(retorno.listaCartorio);
      this.critica.controls.assuntos.setValue(retorno.assuntos);
    });

  }

  gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

    this.critica.controls.nome.setValue(manifestante.nome);
    this.critica.controls.email.setValue(manifestante.email);
    this.critica.controls.username.setValue(this.authService.usuarioLogado.username);

    this.critica.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.critica.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    return isEnviar ? this.enviar(this.critica.getRawValue()) : this.salvar(this.critica.getRawValue());

  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  enviar(obj) {
    return this.rest.post(`${URL_API.PATH_CRITICA}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  gravar(obj) {
    return this.rest.post(`${URL_API.PATH_CRITICA}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  atualizar(obj: CriticaVO) {
    return this.rest.put(`${URL_API.PATH_CRITICA}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  preencherVo() {
    return {
      id: null,
      files: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      assunto: new FormControl(null, [Validators.required]),
      descricaoCritica: new FormControl(null, [Validators.required]),
      nome: new FormControl({ value: null }, [Validators.required]),
      email: new FormControl({ value: null }, [Validators.required]),

      listaCartorio: [],
      municipio: new FormControl({ value: null, disabled: false }),
      cartorio: new FormControl({ value: null, disabled: true }),
      localidade: new FormControl({ value: null, disabled: true }),

      listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      assuntos: [],

      demandaRecebida: new FormControl(null)

    } as CriticaVO;
  }
}
